import $ from "jquery";
import { areas } from "../framework/areas";
import { logger } from "../framework/logger";
import { regions } from "../framework/regions";
import { services } from "../services/notificationService";

function init() {
    regions.getRegions().done(populateRegions);
    $("#selectRegion").change(onRegionChanged);
}

function populateRegions(lregions) {
    if (!lregions || !lregions.length) {
        services.notificationService.error("There has been an unexpected error loading regions.  Please try again later.");
        logger.error("Unable to load regions, regions may not have been seeded.");
        return;
    }
    const regionSelect = $("#selectRegion");
    const areaSelect = $("#selectArea");

    //Clear selects except for default options.
    regionSelect.find("option").not(":first").remove().end();
    areaSelect.find("option").not(":first").remove().end();

    for (let i = 0; i < lregions.length; i++) {
        regionSelect.append("<option value='" + lregions[i].id + "'>" + lregions[i].regionNumber + "</option>");
        if (!lregions[i].areas || !lregions[i].areas.length) continue;
        for (let j = 0; j < lregions[i].areas.length; j++) {
            areaSelect.append("<option value='" + lregions[i].areas[j].id + "'>" + areas.getAreaName(lregions[i].areas[j]) + "</option>");
        }
    }
}

function onRegionChanged() {
    regions.getRegions().done(function(lregions) {
        const selectedRegion = $("#selectRegion").val();
        if (!selectedRegion || selectedRegion === "")
            return;

        const selectedRegionObj = lregions.find(function(region) {
            return region.id === parseInt(selectedRegion);
        });

        if (selectedRegionObj && selectedRegionObj.areas && selectedRegionObj.areas.length) {
            const selectArea = $("#selectArea");
            selectArea.find("option").not(":first").remove().end();
            for (let i = 0; i < selectedRegionObj.areas.length; i++) {
                selectArea.append("<option value='" + selectedRegionObj.areas[i].id + "'>" + areas.getAreaName(selectedRegionObj.areas[i]) + "</option>");
            }
        }
    });
}

function getFilters() {
    return {
        roleId: toIntOrNull($("#selectRole").val()),
        tagId: toIntOrNull($("#selectTag").val()),
        editionId: toIntOrNull($("#selectEdition").val()),
        regionId: toIntOrNull($("#selectRegion").val()),
        areaId: toIntOrNull($("#selectArea").val()),
        expired: $("#searchExpired").is(":checked"),
        military: $("#searchMilitary").is(":checked"),
        surgeon: $("#searchSurgeon").is(":checked")
    };
}
function getQueryStringFilters() {
    const filters = getFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    return filters;
}
function toIntOrNull(val) {
    const parsed = parseInt(val);
    if (isNaN(parsed)) { return null; }
    return parsed;
}

export const personReportFilters = {
    init: init,
    getFilters: getFilters,
    getQueryStringFilters: getQueryStringFilters
};